import { render, staticRenderFns } from "./BusinessesList.vue?vue&type=template&id=5344ecee&scoped=true&"
import script from "./BusinessesList.vue?vue&type=script&lang=js&"
export * from "./BusinessesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344ecee",
  null
  
)

export default component.exports